import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LegalFaqComponent } from './legal-faq.component';

const routes: Routes = [{ path: '', component: LegalFaqComponent, data: { titleKey: 'TITLE.FAQ', ogKey: 'FAQ' } }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LegalFaqRoutingModule { }

